<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1783yIl/tc-custom/cover.jpg?1690673583284?1721416890203" alt="This image is the cover for the book Empress of the Sun, Everness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Empress of the Sun, Everness
      </h1>
      <p class="bookDescription body article font2">
        <p>The airship Everness makes a Heisenberg Jump to an alternate Earth unlike any her crew has ever seen. Everett, Sen, and the crew find themselves above a plain that goes on forever in every direction without any horizon. They’ve arrived on an Alderson Disc, an astronomical megastructure of incredibly strong material reaching from the orbit of Mercury to the orbit of Jupiter.<br/><br/>Who could have  built such a thing?  The Jiju, the dominant species on a plane where the dinosaurs didn't die out. They evolved, diversified, and have a twenty-five million year technology head-start on humanity.  If they ever get off their plane, and into the worlds of the Plenitude...<br/><br/>Everness has jumped right into the midst of a faction fight between rival nations, but can anyone be safe among the warring Jiju, and what is the price of their help?<br/><br/>The crew of the Everness is divided in a very alien world, a world fast approaching the point of apocalypse.  And back in the Plenitude of Known Worlds, Charlotte Villiers gathers allies and works her way deep into the corridors of power.<br/><br/><b>Praise for Empress of the Sun</b><br/><br/>“YA or not, the Everness series may be the most enjoyable ongoing series that SF currently has to offer.” —<i>Locus</i><br/>“The marvelous Everness series takes readers to a world with highly evolved dinosaurs in this third voyage through parallel universes... McDonald lets his imagination run rampant without abandoning credibility, tackling real scientific concepts such as confirmation bias, a feature lacking in far too much science fiction… Endlessly fascinating and fun.” —<i>Kirkus</i> (Starred Review)<br/>“With strong characters covering all ages and genders, fine action sequences, and enough cool SF concepts that could fill a volume twice its size, EMPRESS OF THE SUN is an excellent entry in one of my favorite SF series.” —<i>SF Signal</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian McDonald
      </h2>
      
      <p class="authorDescription body article">Ian McDonald is the author of many award-winning and critically-acclaimed science fiction novels, including <i>Brasyl</i>, <i>River of Gods</i>, <i>Cyberabad Days</i>, <i>The Dervish House</i>, and the ground-breaking <i>Chaga</i> series. He has won the Philip K. Dick Award, the BSFA Award (five times), LOCUS Award, a Hugo Award, and the Theodore Sturgeon Memorial Award. His work has also been nominated for the Nebula Award, a Quill Book Award, and has several nominations for the Arthur C. Clarke Award. He lives in Belfast, Northern Ireland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15ab7b86